enum SortingOptions {
  Ascending = 'asc',
  Descending = 'desc',
  Summary = 'summary',
  Status = 'status',
  Reporter = 'reporter',
  Key = 'key',
  Created = 'created',
  Updated = 'updated'
}

export default SortingOptions;
